import _ from "lodash";
import React, { Component } from "react";
import Select from "react-select";

export default function (props) {
  const isMulti = props.multi || props.isMulti
  let options = props.options
  if (props.valueKey && props.labelKey) {
    options = []
    props.options.forEach((option) => {
      options.push({
        ...option,
        value: option[props.valueKey],
        label: option[props.labelKey]
      })
    })
  }

  let value = props.value
  if (isMulti) {
    if (!_.has(value[0], 'value')) {
      // Not already an object
      value = options.filter(el => props.value.some((value) => value === el.value)) || []
    }
  } else {
    if (!_.has(value, 'value')) {
      // Not already an object
      value = options.find(el => el.value === props.value) || ""
    }
  }
  
  return (
    <Select {...props}
      components={{
        IndicatorSeparator: () => null
      }}
      inputId={props.inputId || props.id || props.name}
      value={value}
      onChange={props.onChange}
      options={options}
      classNamePrefix="Select"
      isMulti={isMulti}
      classNames={{
        control: (state) =>
          state.isFocused ? 'tw-border-red-600 tw-p-1' : 'tw-p-1',
      }}
    />
  );


}